import React from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'

import { tc, tnc } from '@ulule/localize'
import { DropdownFilter } from '@ulule/owl-kit-components'

import * as S from './styles'

const getTitle = (context = 'discover', projectCount, { tagName }) => {
  switch (context) {
    case 'discover':
      return tnc('[strong: %(nb)d beautiful story]', '[strong: %(nb)d beautiful stories] sorted by', projectCount, {
        nb: projectCount,
        strong: <strong />
      })
    case 'category':
    case 'channel': {
      if (projectCount === 0) {
        return tc('[strong: No %(tagName)s projects] corresponding to this filter', {
          strong: <strong />,
          tagName
        })
      }

      return tnc(
        '[strong: %(nb)d %(tagName)s project]',
        '[strong: %(nb)d %(tagName)s projects] sorted by',
        projectCount,
        {
          nb: projectCount,
          strong: <strong />,
          tagName
        }
      )
    }
    default:
      break
  }
}

const SortingBar = ({ context, count, currentSorting, labelOptions, sorting, updateSorting, withBigTitle }) => (
  <S.SortingBarContainer withBigTitle={withBigTitle}>
    {getTitle(context, count, labelOptions)}
    {count > 1 && (
      <MediaQuery maxWidth={1019}>
        <DropdownFilter
          inline
          useDefault
          name="sorting"
          value={currentSorting}
          options={sorting}
          onChange={event => {
            updateSorting({ value: event.target.value })
          }}
        />
      </MediaQuery>
    )}
    {count > 1 && (
      <MediaQuery minWidth={1020}>
        <DropdownFilter inline name="sorting" value={currentSorting} options={sorting} onChange={updateSorting} />
      </MediaQuery>
    )}
  </S.SortingBarContainer>
)

SortingBar.defaultProps = {
  context: 'discover',
  labelOptions: {},
  withBigTitle: false
}

SortingBar.propTypes = {
  context: PropTypes.string,
  count: PropTypes.number,
  currentSorting: PropTypes.string.isRequired,
  labelOptions: PropTypes.shape({
    tagName: PropTypes.string
  }),
  sorting: PropTypes.array.isRequired,
  updateSorting: PropTypes.func.isRequired,
  withBigTitle: PropTypes.bool
}

export default SortingBar
